import { render, staticRenderFns } from "./Followuplist.vue?vue&type=template&id=7c0c5687&"
import script from "./Followuplist.vue?vue&type=script&lang=js&"
export * from "./Followuplist.vue?vue&type=script&lang=js&"
import style0 from "./Followuplist.vue?vue&type=style&index=0&id=7c0c5687&lang=css&"
import style1 from "./Followuplist.vue?vue&type=style&index=1&id=7c0c5687&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c0c5687')) {
      api.createRecord('7c0c5687', component.options)
    } else {
      api.reload('7c0c5687', component.options)
    }
    module.hot.accept("./Followuplist.vue?vue&type=template&id=7c0c5687&", function () {
      api.rerender('7c0c5687', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/Followup/Followuplist.vue"
export default component.exports